import React, { useEffect } from "react";
import { Field, Form, useFormikContext } from "formik";
import TextBox from "../../../components/forms/text-box";
import { useTranslation } from "react-i18next";
import Button from "components/button";
import GuestOrderStatusForm, { GuestOrderStatusFormStep } from "../types/guest-order-status-form";
import Captcha from "../../../components/forms/captcha";
import styled from "styled-components";

const UserMessage = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
`;

const RequestOTPForm: React.FC = () => {
  const { t } = useTranslation();
  const { setFieldValue, values, isSubmitting } = useFormikContext<GuestOrderStatusForm>();

  useEffect(
    () => {
      setFieldValue("step", GuestOrderStatusFormStep.RequestOTP);
    },
    [setFieldValue],
  );

  return (
    <Form>
      <UserMessage>{t("order.caseSensitiveUserMessage")}</UserMessage>
      <Field
        label={t("contactemail")}
        name="emailAddress"
        placeholder={t("contactemail")}
        component={TextBox}
        value={values.emailAddress}
        required
        readOnly={isSubmitting}
      />
      <Field
        label={t("orderstatus.HPorderNumber")}
        name="orderNumber"
        placeholder={t("orderstatus.HPorderNumber")}
        component={TextBox}
        value={values.orderNumber}
        required
        readOnly={isSubmitting}
      />
      <Field
        name="captcha"
        component={Captcha}
      />
      <Button type="submit" loading={isSubmitting}>{t("btn.submit")}</Button>
    </Form>
  );
};

export default RequestOTPForm;
